export class CargoHostDialogParams {
	readonly titleTranlationKey: string;
	readonly cargoFormUrl: string;
	readonly isPreviewRequired: boolean;

	constructor (titleTranlationKey: string, cargoFormUrl: string, isPreviewRequired: boolean) {
		this.titleTranlationKey = titleTranlationKey;
		this.cargoFormUrl = cargoFormUrl;
		this.isPreviewRequired = isPreviewRequired;
	}
}
